<template>
    <div>
        <v-dialog :return-value="retval" maxWidth="500" v-model="editComment">
            <v-toolbar dense dark color="primary">
                <v-toolbar-title>Edit Comment</v-toolbar-title>
            </v-toolbar>
            <v-card>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-text-field outlined dense hide-details autofocus v-model="selectedCommentClone.text"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <v-spacer>
                    </v-spacer>
                    <v-btn color="primary" outlined @click="cancelUpdate">Cancel</v-btn>
                    <v-btn depressed @click="update" color="primary">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-data-table style="max-height: 600px; overflow-y: auto;" hide-actions hide-headers hide-default-footer
                      disable-pagination :items="comments">
            <template v-slot:item="{item}">
                <tr :class="item.idnr === selectedCommentClone.idnr ? 'gx-table-row-selected' : ''"
                    @click="handleRowClick(item);"
                    @mouseover="$emit('row-mouseover', item)" @mouseout="$emit('row-mouseout')">
                    <td>
                        <v-text-field dense outlined hide-details @click.stop="handleRowClick(item); editComment = true"
                                      :label="item.text ? '' : 'Click to add comment'"
                                      :value="item.text"></v-text-field>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import Swatches from 'vue-swatches'

  export default {

    name: 'CommentTable',

    props: {
      selectedComment: {
        type: Object,
        default() {
          return {
            value: '',
            idnr: null,
            text: null
          }
        }
      },
      comments: {
        type: Array,
        default() {
          return []
        }
      }
    },

    watch: {
      //If the selected route changes, make sure to reclone it
      selectedComment(after) {
        if (after === null) {
          this.selectedCommentClone = {
            idnr: null,
            text: ''
          }
        } else {
          this.selectedCommentClone = _.clone(after)
        }
      }
    },

    data() {
      return {
        retval: null,
        editComment: false,
        swatchOpen: false,
        selectedRowIndex: null,
        selectedCommentClone: {
          value: '',
          idnr: null,
          text: null
        }
      }
    },

    methods: {
      cancelUpdate() {
        this.editComment = false;
        this.recloneComment();
        //this.$emit('deselect');
      },
      emitComment() {
        this.$emit('comment-update', this.selectedCommentClone)
      },
      handleRowClick(row) {
        console.log("RoutePlotTable -- handleRowClick: ");
        this.$emit('row-select', row);
        this.selectedRowIndex = row.idnr;
        this.selectedCommentClone = _.cloneDeep(row);
      },
      handleSwatchInput(data) {
        console.log("RoutePlotTable -- handleSwatchInput: ");
        console.dir(data)
        this.swatchOpen = false;
        this.selectedRouteClone.colour = data;
        this.emitComment()
      },
      update() {
        this.editComment = false;
        this.$emit('comment-update', this.selectedCommentClone)
      },
      /**
       * Reset selectedCommentClone from the selectedComment prop
       */
      recloneComment() {
        if (this.selectedComment === null) {
          this.selectedCommentClone = {
            idnr: null,
            text: ''
          }
        } else {
          this.selectedCommentClone = _.cloneDeep(this.selectedComment)
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
